import React from 'react';
import { X } from 'lucide-react';

type Props = {
  imageUrl: string;
  recipeName: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function ImageViewer({ imageUrl, recipeName, isOpen, onClose }: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors"
        aria-label="Fermer"
      >
        <X size={24} />
      </button>
      
      <div className="w-full h-full flex items-center justify-center p-4">
        <img
          src={imageUrl}
          alt={recipeName}
          className="max-w-full max-h-full object-contain rounded-lg"
          onClick={onClose}
        />
      </div>
      
      <div className="absolute bottom-4 left-4 right-4 text-center">
        <p className="text-white text-lg font-medium">{recipeName}</p>
        <p className="text-white/70 text-sm mt-1">Appuyez pour fermer</p>
      </div>
    </div>
  );
}